import type { Ref } from 'vue';
import { watch, ref } from 'vue';
import type { MentionParticipant } from '@getaccept/lib-shared/src/contextual-commenting/mentions/types/mention-participant';

export const useMentionsKeybindings = (
  mentionParticipants: Ref<MentionParticipant[]>,
  showMentionParticipants: Ref<boolean>
) => {
  const selectedIndex = ref(0);

  watch(mentionParticipants, (newValue: MentionParticipant[], oldValue: MentionParticipant[]) => {
    if (newValue.length === oldValue.length) {
      return;
    }
    if (selectedIndex.value > newValue.length - 1) {
      selectedIndex.value = newValue.length - 1;
    }
  });

  const handlePressDown = (event: KeyboardEvent) => {
    if (showMentionParticipants.value === false) {
      return;
    }
    event.preventDefault();
    if (selectedIndex.value + 1 < mentionParticipants.value.length) {
      selectedIndex.value++;
    }
  };

  const handlePressUp = (event: KeyboardEvent) => {
    if (showMentionParticipants.value === false) {
      return;
    }
    event.preventDefault();
    if (selectedIndex.value > 0) {
      selectedIndex.value--;
    }
  };

  return { selectedIndex, handlePressDown, handlePressUp };
};
